import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-thumbnail',
  templateUrl: './thumbnail.component.html',
  styleUrls: ['./thumbnail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ThumbnailComponent implements OnInit {
  get imgSrc(): string {
    return this._imgSrc;
  }

  get styles(): object {
    return {
      'background-image': 'url(' + this.imgSrc + ')',
    }
  }

  get pixelSize(): number {
    switch (this.size) {
      case 'xxs': return 20;
      case 'xs': return 24;
      case 'sm': return 30;
      case 'md': return 36;
      case 'lg': return 60;
      case 'xl': return 100;
      default: return 36;
    }
  }

  @Input() set imgSrc(value: string) {
    this._imgSrc = value;
  }
  @Input() public classList: string;
  @Input() public stylesList: string;
  @Input() public size: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'md';
  @Input() public isOnline = false;
  @Input() public bordered: boolean;
  @Input() public circle: boolean;
  private _imgSrc: string;

  constructor() { }

  ngOnInit(): void {
  };



}
